/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { _date } from '@mairistem/administres-utils';
import { Table } from '@mairistem/composants';

import type { Acte } from '@/types';
import { formatHeure, trimComma } from '@/utils';

interface Props {
  acte: Acte;
}

const ActeTableLineMariage = ({ acte }: Props) => {
  const heure = formatHeure(acte.heureMariage, acte.minuteMariage);
  const dateMariage = [_date.short(acte.dateMariage ?? ''), heure]
    .filter(Boolean)
    .join(' - ');

  return (
    <>
      <Table.Cell content={dateMariage} />
      <Table.Cell content={trimComma(acte.conjoint1)} />
      <Table.Cell content={trimComma(acte.conjoint2)} />
    </>
  );
};

export default ActeTableLineMariage;
